import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

function MessageBox(props) {
  const handleClose_true = () => {
    props.handleClose(true);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.question}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose_true} color="primary">
            Sluit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MessageBox;
